import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import StorageUnitChecks from './components/StorageUnitChecks';

const storageUnitChecks = (props,{ t }) => (
  <Container>
    <StorageUnitChecks {...props} />
  </Container>
);

storageUnitChecks.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(storageUnitChecks);
